module.exports = function() {
  return new Worker(__webpack_public_path__ + "95f4fb407854fca0e9d8.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/web-workers/Decoder.worker.ts
// module id = 898
// module chunks = 0